import { css } from "@emotion/react";
import type { ColorProfileTheme } from "aviary-tokens";

export const pill = css`
  white-space: nowrap;
`;

export const iconTooltip = css`
  height: 40px;
  width: 40px;
`;

export const icon = {
  base: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    padding: 0.1875rem;
    border-radius: 50%;
  `,
  intention: (profile: ColorProfileTheme) => css`
    path {
      fill: ${profile.textHover};
    }
    background-color: ${profile.backgroundMuted};
  `,
};
